import { render, staticRenderFns } from "./samba.vue?vue&type=template&id=3bee895c&"
import script from "./samba.vue?vue&type=script&lang=js&"
export * from "./samba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports